import { gql } from '@apollo/client'

const ADD_NEW_REJECT_REASON = gql`
  mutation ADD_NEW_REJECT_REASON($generatedID: ID!, $name: String!, $order: Int) {
    addNewRejectReason(generatedID: $generatedID, name: $name, order: $order) {
      id
      name
      order
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`

export default ADD_NEW_REJECT_REASON
